import { Form } from './Form'
import { Header } from './Header'

const Step6 = {
  Header,
  Form,
}

export default Step6
